import * as Sentry from "@sentry/vue";

export default defineNuxtPlugin({
  name: "sentry",
  parallel: true,
  async setup(app) {
    const APOLLO_ERROR = /^Response not successful: Received status code 401$/;

    const runtimeConfig = useRuntimeConfig();

    const sentry = Sentry.init({
      app: app.vueApp,
      dsn: "https://0ad3ed54831c42ffb8e572f351e0df01@o574608.ingest.us.sentry.io/5725825",

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 0.5,
      environment: runtimeConfig.public.buildVariant,
      release: runtimeConfig.public.version,
      logErrors: true,
      ignoreErrors: [APOLLO_ERROR],
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          blockAllMedia: true,
        }),
      ],
      tracePropagationTargets: ["router.align.bi", "router-test.align.bi"],
      // Limit serialization depth to prevent Sentry's normalizer from walking into
      // Nuxt's reactive runtime config proxy (which warns on any non-public key access).
      normalizeDepth: 3,
    });

    return { provide: { sentry } };
  },
});
